import { isNil } from 'lodash-es';

export function formatQuantity(
  value?: number | null,
  {
    fallback,
  }: {
    fallback?: string;
  } = {},
) {
  if (isNil(value)) {
    return fallback;
  }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
